// Recoil States
import {atom} from "recoil";

export const plantState = atom({
    key: 'plantState',
    default: [],
});

